import React, { useState, useEffect, useRef } from 'react';
import { Input, Select, Radio, message, AutoComplete } from 'antd';
import '../ResourceStyle.css';
import {
    create_upload_faq_actionHandler,
    create_topic_ques_list_actionHandler,
} from '../../../../../Redux/Actions/user/CreateUploadFAQ';
import { create_upload_faq_topic_list_actionHandler } from '../../../../../Redux/Actions/user/CreateUploadFAQTopicList';
import { useSelector, useDispatch } from 'react-redux';
import { CloseSquareFilled } from '@ant-design/icons';
import { CKEditor } from "@ckeditor/ckeditor5-react";
// import Editor from "@juniyadi/ckeditor5-custom-build";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {CKEdiorConfig} from "../../../../../Config/CKEdiorConfig";


const { TextArea } = Input;
const UploadFAQ = () => {
    const [topicName, setTopicName] = useState('');
    const [parent, setParent] = useState('');
    const [answer, setAnswer] = useState('');
    const [answerSub, setAnswerSub] = useState('');
    const [topicTouched, setTopicTouched] = useState(false);
    const [parentTouched, setParentTouched] = useState(false);
    const [answerTouched, setAnswerTouched] = useState(false);
    const [subQues, setSubQues] = useState('');
    const [subQuesTouched, setSubQuesTouched] = useState(false);
    const [subAnswer, setSubAnswer] = useState('');
    const [subAnswerTouched, setSubAnswerTouched] = useState(false);
    const [question, SetQuestion] = useState('');
    const [parentQuesID, setParentQuesId] = useState(null);
    const [topicId, setTopicId] = useState(null);
    const [topicOptions, setTopicOptions] = useState([]);

    const [inputValue, setInputValue] = useState('');
    const [text, setText] = useState('');
    const editorRef = useRef();
    const handleChange = (label) => {
        const selectedTopic = Array.isArray(label) ? label[0] : label;
        setInputValue(label);
        setTopicName(selectedTopic);
        // setTopicQ(selectedTopic);
    };

    const handleFormSubmit = () => {
        const actionPayload = {
            topic_name: topicName,
            question_type: radioValue,
            question: parent.length > 0 ? parent : question,
            answer: answer.length > 0 ? answer : answerSub,
            parent_question_id: parentQuesID,
            topic_id: topicId,
        };
        dispatch(create_upload_faq_actionHandler(actionPayload));
        message.success('Submitted Successfully');

        resetForm();
    };

    const resetForm = () => {
        setParent('');
        setAnswer('');
        editorRef.current.editor.setData('');
        setSubQues('');
        setSubAnswer('');
        setParentTouched(false);
        setAnswerTouched(false);
        setSubQuesTouched(false);
        setSubAnswerTouched(false);
        setAnswerSub('');
        SetQuestion('');
    };

    const getQuestion = useSelector(
        (state) =>
            state.create_topic_ques_list_data?.create_topic_ques_list_data
    );

    const GetTopicList = useSelector(
        (state) =>
            state.create_upload_faq_topic_list_data
                ?.create_upload_faq_topic_list_data
    );

    const QuestionsList = getQuestion?.data?.map((ques) => ({
        value: ques.id,
        label: ques.question,
    }));

    const handleAutoCompleteSearch = (value) => {
        if (TopicOptions !== undefined && TopicOptions.length > 0) {
            const filteredOptions = TopicOptions.filter((option) =>
                option.label.toLowerCase().includes(value.toLowerCase())
            );
            setTopicOptions(filteredOptions);
        }
    };

    const handleQuesSelect = (label) => {
        const QuesName = QuestionsList?.find((ques) => {
            return ques.value === label;
        });
        setParentQuesId(QuesName.value);
    };
    const TopicOptions = GetTopicList?.data?.map((topic) => ({
        value: topic.id,
        label: topic.name,
    }));

    const handleTopicSelect = (label, option) => {
        setTopicTouched(false);

        const TopicName = TopicOptions?.find((option) => {
            return option.value === label;
        });
        dispatch(create_topic_ques_list_actionHandler(label));
        setTopicId(TopicName.value);
        setTopicName(TopicName.label);
        setInputValue(option.label);
    };

    const [radioValue, setRadioValue] = useState('parent');

    const onChangeCheck = (e) => {
        setRadioValue(e.target.value);
    };

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(create_upload_faq_topic_list_actionHandler());
    }, [dispatch]);
    useEffect(() => {
        const TopicOptionsdata = GetTopicList?.data?.map((topic) => ({
            value: topic.id,
            label: topic.name,
        }));
        setTopicOptions(TopicOptionsdata)
    }, [GetTopicList]);
    const onChangeCkEditor = (event, editor) => {
        const data = editor.getData();
        setAnswer(data);
        // onChange(data);
    }
    const rows = 10; 
    return (
        <div className='faq-main'>
            <div className='for-first'>
                <form
                    className='faqForm'
                    onSubmit={(e) => {
                        e.preventDefault();
                        handleFormSubmit();
                    }}>
                    <div className='faq-input'>
                        <label>Topic</label>

                        <AutoComplete
                            options={topicOptions}
                            value={inputValue}
                            onSearch={handleAutoCompleteSearch}
                            onBlur={() => setTopicTouched(true)}
                            onChange={(event) => handleChange(event)}
                            onSelect={handleTopicSelect}
                            style={{
                                width: 200,
                            }}
                            placeholder='Add Topic Name'
                            allowClear={{
                                clearIcon: <CloseSquareFilled />,
                            }}
                        />
                    </div>

                    <div className='faq-input2'>
                        <label>Add Question</label>
                        <div className='check-div'>
                            <Radio
                                value='parent'
                                checked={radioValue === 'parent'}
                                onChange={onChangeCheck}>
                                Parent Question
                            </Radio>
                            <Radio
                                value='sub'
                                checked={radioValue === 'sub'}
                                onChange={onChangeCheck}>
                                Sub-Question
                            </Radio>
                        </div>
                    </div>

                    {radioValue === 'parent' && (
                        <div className='faq-simple'>
                            <label>Parent Question</label>
                            <Input
                                value={parent}
                                onBlur={() => setParentTouched(true)}
                                onChange={(e) => setParent(e.target.value)}
                                placeholder='How can we create QuickAction?'
                            />
                            {parentTouched && !parent && (
                                <div className='validation-error'>
                                    Please enter parent question.
                                </div>
                            )}
                        </div>
                    )}

                    {radioValue === 'parent' && (
                        <div className='faq-simple'>
                            <label>Parent Answer</label>
                            {/* <TextArea
                                value={answer}
                                onBlur={() => setAnswerTouched(true)}
                                onChange={(e) => setAnswer(e.target.value)}
                                placeholder='Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime non distinctio recusandae.'
                                autoSize={{
                                    minRows: 3,
                                    maxRows: 5,
                                }}
                            /> */}
                            <CKEditor
                                editor={ClassicEditor}
                                onBlur={() => setAnswerTouched(true)}
                                placeholder='Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime non distinctio recusandae.'
                                onChange={(event, editor) => onChangeCkEditor(event, editor)}
                                style={{ height: `${rows * 25}px` }}
                                value={answer}
                                ref={editorRef}
                                config={{toolbar: CKEdiorConfig}}
                            />

                            {answerTouched && !answer && (
                                <div className='validation-error'>
                                    Please enter parent Answer.
                                </div>
                            )}
                        </div>
                    )}

                    {radioValue === 'sub' && (
                        <div className='faq-simple Parent-ques'>
                            <div className='faq-input'>
                                <label>Parent Question</label>
                                <Select
                                    showSearch
                                    style={{ width: '60%' }}
                                    placeholder='What is QuickAction?'
                                    optionFilterProp='children'
                                    onChange={() => { }}
                                    onSelect={handleQuesSelect}
                                    options={QuestionsList}
                                />
                            </div>

                        </div>
                    )}

                    {radioValue === 'sub' && (
                        <div className='faq-simple Sub-Ques'>
                            <label>Sub-Question</label>
                            <Input
                                // onBlur={() => setSubQuesTouched(true)}
                                onChange={(e) => SetQuestion(e.target.value)}
                                value={question}
                                placeholder='How can we create QuickAction?'
                            />
                        </div>
                    )}

                    {radioValue === 'sub' && (
                        <div className='faq-simple Sub-answer'>
                            <label>Sub-Question Answer</label>
                            {/* <TextArea
                                // onBlur={() => setSubAnswerTouched(true)}
                                onChange={(e) => setAnswerSub(e.target.value)}
                                value={answerSub}
                                placeholder='Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime non distinctio recusandae.'
                                autoSize={{
                                    minRows: 3,
                                    maxRows: 5,
                                }}
                            /> */}
                            <CKEditor
                                editor={ClassicEditor}
                                onBlur={() => setAnswerTouched(true)}
                                placeholder='Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime non distinctio recusandae.'
                                onChange={(event, editor) => onChangeCkEditor(event, editor)}
                                style={{ height: `${rows * 25}px` }}
                                value={answer}
                                ref={editorRef}
                                config={{toolbar: CKEdiorConfig}}
                            />
                            {/* {subAnswerTouched && !subAnswer && (
                <div className="validation-error">Please enter sub answer.</div>
              )} */}
                        </div>
                    )}
                    {radioValue && (
                        <div className='ques-div'>
                            <button className='ques-btn'>
                                Submit Question
                            </button>
                        </div>
                    )}
                </form>
            </div>

        </div>
    );
};

export default UploadFAQ;
